import { MdsIconKind } from "@/design-system/components/icon";

export enum MDSBadgeVariant {
  Default = "default",
  Emphasis = "emphasis",
  MoreEmphasis = "more-emphasis",
  EmphasisBig = "emphasis-big",
  Negative = "negative",
}

export interface IMDSBadgeProps {
  /** Optional icon to render to the left of the label */
  icon?: MdsIconKind;
  /** Text label to display inside the badge */
  label: string;
  /** Visual weight of the badge background */
  variant?: MDSBadgeVariant;
  className?: string;
  id?: string;
  /** Optional slot for custom placement in parent components */
  slot?: string;
}
